import { URL_MODULE_MAP } from '../constants/Constants';

/**
 * @description Function to load tapchat script file
 * @param {String} apiBaseUrl - Api base url
 */
export const initializeTapChat = (tapChatBaseUrl, onLoad) => {
  const scriptUrl = "".concat(tapChatBaseUrl, "/tapchat.js");
  try {
    const scriptTag = document.createElement('script');
    scriptTag.src = scriptUrl;
    if (onLoad) {
      scriptTag.addEventListener('load', onLoad);
    }
    document.body.appendChild(scriptTag);
  } catch (err) {
    console.error(err);
  }
};

/**
 * @description Function to get the module name based on the current page url
 */
export const getModuleName = () => {
  const {
    pathname
  } = window.location;
  const slashIndex = pathname.indexOf('/', 1);
  return URL_MODULE_MAP[pathname.substr(0, slashIndex)] || 'monitor';
};